<script setup lang="ts">
import { useAuth } from '@/composables/useAuth'
import { isTestCafeAuthEnabled, isTestCafeEnabled } from '@/helpers/isTestCafeEnabled'
import { configureCompat } from 'vue'
import { RouterView } from 'vue-router'

import ForcedLogoutModal from '@/components/widgets/modal/ForcedLogoutModal.vue'
import InactivityModal from '@/components/widgets/modal/InactivityModal.vue'
import ApToaster from '@/components/widgets/toast/ApToaster.vue'

configureCompat({
  MODE: 2,
  COMPONENT_V_MODEL: false,
  WATCH_ARRAY: false
})

useAuth()
</script>

<template>
  <div id="app" :class="{ testcafe: isTestCafeEnabled() || isTestCafeAuthEnabled() }">
    <InactivityModal></InactivityModal>
    <ForcedLogoutModal></ForcedLogoutModal>
    <ApToaster />
    <suspense>
      <RouterView />
    </suspense>
  </div>
</template>

<style scoped lang="scss"></style>
